import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { KycMethodSelectionContainer } from "./key-method-selection.container";
import { KycMethodSelectionDialogContainer } from "./kyc-method-selection-dialog.container";
import { KycVerificationPage } from "./kyc-verification.page";
import { KycMethodSelectionEffect } from "./sdk/kyc-method-selection.effect";
import { KycVerificationConfigService } from "./sdk/kyc-verification.config";
import { KycVerificationEffect } from "./sdk/kyc-verification.effect";
import { kycVerificationSelector } from "./sdk/kyc-verification.reducer";
import { KycVerificationService } from "./sdk/kyc-verification.service";

const DIRECTIVES: any[] = [KycVerificationPage, KycMethodSelectionDialogContainer, KycMethodSelectionContainer];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		GlobalUiModule,
		DialogLayoutModule,
		EffectsModule.forFeature([KycVerificationEffect, KycMethodSelectionEffect]),
		StoreModule.forFeature("kycVerification", kycVerificationSelector),
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	providers: [KycVerificationService, KycVerificationConfigService],
})
export class KycVerificationModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, KycMethodSelectionDialogContainer);
	}
}
